// 외부 호출 — 응답은 경계에서 파싱해 도메인 타입으로 바꾼다 (Parse, don't validate)
import type { Health } from '../domain/health';
import type { HealthSource } from '../ports/health-source';

export function parseHealth(body: unknown, now: Date): Health {
  const status = (body as { status?: unknown } | null)?.status;
  return { status: status === 'ok' ? 'ok' : 'down', checkedAt: now };
}

export function createHttpHealthSource(baseUrl = '/api'): HealthSource {
  return {
    async fetchHealth(signal) {
      const res = await fetch(`${baseUrl}/health`, { signal });
      if (!res.ok) return { status: 'down', checkedAt: new Date() };
      return parseHealth(await res.json(), new Date());
    },
  };
}
